import {
  GET_ALL_CARRIERS,
  GET_ALL_CARRIERS_ZH_COD
} from 'src/store/mutation-types'

export default {
  [GET_ALL_CARRIERS] (state, carriers) {
    state.carriers = carriers
  },
  [GET_ALL_CARRIERS_ZH_COD] (state, carrierZhs) {
    state.carrierZhs = carrierZhs
  }
}



// WEBPACK FOOTER //
// ./src/components/carrier/store/mutations.js